import React, { FC, ReactNode } from "react";

export type SidebarProps = FC<{
  children: ReactNode;
}>;

const Sidebar: SidebarProps = ({ children }) => <>{children}</>;

export default Sidebar;
